import { Link } from 'react-router-dom';
import { getRecommendedDramas } from '@/mocks/dramas';

export default function FeaturedSection() {
  const recommended = getRecommendedDramas();

  if (recommended.length === 0) return null;

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              口碑炸裂的高分好剧，不容错过
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {recommended.slice(0, 2).map((drama) => (
            <Link
              key={drama.slug}
              to={`/detail/${drama.slug}`}
              className="group relative h-[220px] md:h-[280px] rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={drama.bannerImage}
                alt={drama.title}
                title={drama.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 text-xs rounded-md bg-primary-500 text-white">
                    {drama.rating}
                  </span>
                  <span className="text-xs text-white/70">{drama.region} · {drama.episodeCount}集</span>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-2">
                  {drama.title}
                </h3>
                <p className="text-xs md:text-sm text-white/70 line-clamp-2 leading-relaxed">
                  {drama.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-6">
          {recommended.slice(2).map((drama) => (
            <Link
              key={drama.slug}
              to={`/detail/${drama.slug}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="w-20 md:w-24 shrink-0 overflow-hidden rounded-lg">
                <img
                  src={drama.coverImage}
                  alt={drama.title}
                  title={drama.title}
                  className="w-full aspect-[3/4] object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-center">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                  {drama.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                  <span className="flex items-center">
                    <i className="ri-star-fill text-accent-500 mr-0.5"></i>
                    {drama.rating}
                  </span>
                  <span>{drama.updateInfo}</span>
                </div>
                <div className="flex flex-wrap gap-1">
                  {drama.tags.slice(0, 2).map((tag) => (
                    <span key={tag} className="px-1.5 py-0.5 text-xs rounded bg-secondary-100 text-secondary-800">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}